import React, { useState } from 'react';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import MapIcon from '../../assets/images/logo_icon.png';

const containerStyle = {
    width: '100%',
    height: '100%'
};

const center = {
    lat: -3.745,
    lng: -38.523
};

function GoogleMapComponent() {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyA9PRZ4LU9yTqlpV6d7-GH11B70BZKVJOU"
    });

    const [map, setMap] = React.useState(null);

    const onLoad = React.useCallback(function callback(map) {
        // Check if window.google.maps is defined before using it
        if (window.google && window.google.maps) {
            const bounds = new window.google.maps.LatLngBounds(center);
            map.fitBounds(bounds);
        }

        setMap(map);
    }, []);

    const onUnmount = React.useCallback(function callback() {
        setMap(null);
    }, []);

    const customMarkerIcon = {
        url: MapIcon,
        scaledSize: window.google && window.google.maps ? new window.google.maps.Size(40, 40) : null,
    };

    const [activeMarker, setActiveMarker] = useState(null);


    const handleActiveMarker = (marker) => {
        setActiveMarker(marker);
    }

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            onLoad={onLoad}
            onUnmount={onUnmount}
            onClick={() => setActiveMarker(null)}
        >
            {map && (
                <Marker
                    position={center}
                    icon={customMarkerIcon}
                    onClick={(e) => handleActiveMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() })}
                />
            )}

            {activeMarker && (
                <InfoWindow
                    position={activeMarker}
                    onCloseClick={() => setActiveMarker(null)}
                >
                    <div className="info-window-content">
                        <h5 className="info-window-title">Golf Club Store</h5>
                        <p className="info-window-description">
                            6019 Olivas Park Dr. Suite <br /> C Ventura, California 93003
                        </p>
                    </div>
                </InfoWindow>
            )}
        </GoogleMap>
    ) : <></>;
}

export default GoogleMapComponent;
